<div class="tool-settings-bar row">
  <div id="left-bar" class="col-12 col-lg-5"></div>
  <div id="right-bar" class="col d-flex">
    <div
      *ngIf="searchBarSide === 'right'"
      id="search-input"
      class="col-12 col-sm-6 col-md px-2 d-flex justify-content-end">
      <div style="position: relative">
        <div class="form-group">
          <label style="visibility: hidden">Search</label>
          <input
            [(ngModel)]="searchInput"
            style="height: 40px"
            id="configuration-search-input"
            type="text"
            class="form-control"
            placeholder="Search"
            (keyup.enter)="submitSearch()" />
          <button type="button" class="right" (click)="submitSearch()">
            <i class="fal fa-search"></i>
          </button>
        </div>
      </div>
    </div>
    <ng-container
      *ngIf="['attributes'].includes(configurationSettingsData.type) && isAllowed('job_pointe_configuration', 'edit')">
      <button type="button" id="add-attribute-button" class="btn btn-primary rounded" (click)="submitCreate()">
        {{ configurationSettingsData.type === 'attributes' ? 'Add Attribute' : '' }}
      </button>
    </ng-container>
  </div>
</div>
